import ServiceLocator from 'live/services/service-locator'
import { Transfer } from './components/Transfer'

try {
    ServiceLocator.getService('intervention-header-form').then(service => {
        service.InterventionHeaderFormRegistry.register({
            component: Transfer,
            id: 'well-intervention-kpi-static-data'
        })
    })
} catch (error) {
    console.error('Error registering intervention header form', error)
}
